import React, { useContext, useEffect, useState } from "react";
import AllCompetitors from "./AllCompetitors";
import "./Competitors.css";
import { useUser } from "../../../context/UserContext";
import SuggestedCompetitors from "./SuggestedCompetitors";

export default function CompetitorSuggestions() {
  const { user } = useUser();

  return (
    <div className="container-fluid">
      <div className="row">
        <SuggestedCompetitors user={user} />
      </div>
    </div>
  );
}
